import Header from "../components/Header";
import Footer from "../components/Footer";

export default function TermsConditions() {
    return (
        <>
            <Header />
            <section className="pt-36 pb-24 bg-gradient-to-b from-white to-slate-50">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-2">Terms & Conditions</h1>
                    <p className="text-slate-500 text-sm mb-8">Last updated: June 29, 2026</p>

                    <div className="space-y-8 text-slate-600">

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">1. Agreement to Terms</h2>
                            <p>By accessing or using Adeya IMS, you agree to be bound by these Terms & Conditions. If you disagree with any part of these terms, you may not access the service.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">2. Description of Service</h2>
                            <p>Adeya IMS is an inventory management system that helps businesses track purchases, sales, inventory levels, generate reports, and manage vendors and customers. We reserve the right to modify or discontinue any feature without notice.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">3. User Accounts</h2>
                            <p className="mb-2">You are responsible for:</p>
                            <ul className="list-disc pl-6 space-y-1">
                                <li>Maintaining the confidentiality of your login credentials</li>
                                <li>All activities that occur under your account</li>
                                <li>Notifying us immediately of any unauthorized access</li>
                                <li>Ensuring the accuracy of information you provide</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">4. Subscription and Payment</h2>
                            <p className="mb-2">Our subscription plans are billed monthly or annually. By subscribing, you agree to pay the applicable fees. Fees are non-refundable except as required by applicable law. We reserve the right to change pricing with 30 days' notice.</p>
                            <p className="mt-2">Payments are processed through Razorpay. You agree to provide accurate billing information. Late payments may result in suspension of service.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">5. Cancellation and Refund Policy</h2>
                            <p className="mb-2">You may cancel your subscription at any time by contacting support or through your account settings.</p>
                            <ul className="list-disc pl-6 space-y-1">
                                <li><strong>Refund eligibility:</strong> If you cancel within <strong>15 days</strong> of the initial purchase or renewal date, you are eligible for a full refund.</li>
                                <li><strong>No refund after 15 days:</strong> If you cancel after 15 days, no refund will be provided, and you will continue to have access to the service until the end of your current billing cycle.</li>
                                <li><strong>Partial refunds:</strong> No partial refunds are provided for unused periods.</li>
                                <li><strong>Refund processing:</strong> Refunds, if eligible, will be processed within 7-10 business days via the original payment method.</li>
                            </ul>
                            <p className="mt-2">To request a cancellation or refund, please contact us at <a href="mailto:support@adeyaai.com" className="text-sky-600 hover:underline">support@adeyaai.com</a>.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">6. Data Ownership and Intellectual Property</h2>
                            <p className="mb-2">You retain ownership of all business data you enter into Adeya IMS. We do not claim ownership of your data. You grant us a limited license to store, process, and display your data as necessary to provide the service.</p>
                            <p className="mt-2">The Adeya IMS software, design, logos, and trademarks are our intellectual property and may not be copied or used without permission.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">7. Acceptable Use Policy</h2>
                            <p className="mb-2">You agree NOT to:</p>
                            <ul className="list-disc pl-6 space-y-1">
                                <li>Use the service for any illegal purpose or in violation of any laws</li>
                                <li>Attempt to gain unauthorized access to our systems or other users' accounts</li>
                                <li>Upload malicious code, viruses, or harmful content</li>
                                <li>Interfere with or disrupt the integrity or performance of the service</li>
                                <li>Reverse engineer or decompile any part of the service</li>
                                <li>Use the service to send spam or unsolicited communications</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">8. Service Availability and Support</h2>
                            <p>We strive to maintain 99.9% uptime but do not guarantee uninterrupted access. Scheduled maintenance will be communicated in advance. Support is available via email at support@adeyaai.com, with response times varying by subscription plan (Standard: 24-48 hours, Priority: 2-4 hours).</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">9. Limitation of Liability</h2>
                            <p>To the maximum extent permitted by law, Adeya IMS and its owners, employees, and affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or business interruption. Our total liability shall not exceed the amount you paid us in the six months preceding any claim.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">10. Disclaimer of Warranties</h2>
                            <p>The service is provided "as is" without warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not warrant that the service will be error-free or uninterrupted.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">11. Indemnification</h2>
                            <p>You agree to indemnify and hold harmless Adeya IMS from any claims, damages, losses, or expenses arising from your use of the service, violation of these terms, or infringement of any third-party rights.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">12. Termination</h2>
                            <p>We may terminate or suspend your account immediately, without prior notice, for violation of these terms. Upon termination, your right to use the service will cease. You may export your data before termination if possible.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">13. Governing Law</h2>
                            <p>These terms shall be governed by the laws of India, and any disputes shall be subject to the exclusive jurisdiction of the courts in Pune, Maharashtra.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">14. Changes to Terms</h2>
                            <p>We may update these terms from time to time. We will notify you of material changes by email or through a notice on our platform. Continued use of the service after changes constitutes acceptance of the new terms.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">15. Contact</h2>
                            <p>For questions about these Terms & Conditions, contact us at:</p>
                            <p className="mt-2">
                                <strong>Email:</strong> <a href="mailto:support@adeyaai.com" className="text-sky-600 hover:underline">support@adeyaai.com</a><br />
                                <strong>Phone:</strong> +91 98221 34536<br />
                                <strong>Address:</strong> UI MIDC Phase 4, Akola, Maharashtra 444001, India
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}